import * as React from 'react'

import { Box, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'

interface ButtonProps {
  onClick?: () => void
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
}

interface NavbarProps {
  firstYear: number
  onNextClick?: () => void
  onPreviousClick?: () => void
}

const Button = ({ icon, onClick }: ButtonProps) => {
  const [hover, setHover] = React.useState(false)

  return (
    <Box onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <Touchable onClick={onClick} expand>
        <Icon.Medium icon={icon} color={hover ? 'viridian1000' : 'grey600'} />
      </Touchable>
    </Box>
  )
}

const Navbar = ({ firstYear, onPreviousClick, onNextClick }: NavbarProps) => (
  <Box alignItems="center" justifyContent="spaceBetween" flexDirection="row" padding="s12">
    <Button onClick={onPreviousClick} icon="chevron-left" />
    <Text.Normal weight="medium">
      {firstYear} - {firstYear + 11}
    </Text.Normal>
    <Button onClick={onNextClick} icon="chevron-right" />
  </Box>
)

export default Navbar
